import React from 'react'
import './ShoppingDownload.css'
import shDownload from './../../../Assets/images/shDownload.jpg'
export default function ShoppingDownload() {
  return (
    <section className='ShoppingDownload'>
        <div className="ShoppingDownload__container">
            <section className='ShoppingDownload__right'>
                <h2 className="ShoppingDownload__right__title">
                        دانلود نامحدود
                </h2>
                <p className='ShoppingDownload__right__text'>
                لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است
                </p>
                <button className='ShoppingDownload__right__btn'>
                    <p>                    برو به کافه ویرا</p>
                </button>
            </section>
            <section className='ShoppingDownload__left'>
                <div className="ShoppingDownload__left__item">
                    <div className="ShoppingDownload__left__item__image">
                        <img src={shDownload} alt="" />
                    </div>
                    <div className="ShoppingDownload__left__item__bottom">
                        <div className="ShoppingDownload__left__item__bottom__right">
                            <p className='ShoppingDownload__left__item__bottom__title'>لورم ایپسوم   با تولید سادگی  از  چاپ</p>
                            <p className='ShoppingDownload__left__item__bottom__subtitle'>لورم ایپسوم   با تولید سادگی از چاپ</p>
                        </div>
                        <button className="ShoppingDownload__left__item__bottom__left">
                            مشاهده
                        </button>
                    </div>
                </div>


                <div className="ShoppingDownload__left__item">
                    <div className="ShoppingDownload__left__item__image">
                        <img src={shDownload} alt="" />
                    </div>
                    <div className="ShoppingDownload__left__item__bottom">
                        <div className="ShoppingDownload__left__item__bottom__right">
                            <p className='ShoppingDownload__left__item__bottom__title'>لورم ایپسوم   با تولید سادگی  از  چاپ</p>
                            <p className='ShoppingDownload__left__item__bottom__subtitle'>لورم ایپسوم   با تولید سادگی از چاپ</p>
                        </div>
                        <button className="ShoppingDownload__left__item__bottom__left">
                            مشاهده
                        </button>
                    </div>
                </div>



                <div className="ShoppingDownload__left__item">
                    <div className="ShoppingDownload__left__item__image">
                        <img src={shDownload} alt="" />
                    </div>
                    <div className="ShoppingDownload__left__item__bottom">
                        <div className="ShoppingDownload__left__item__bottom__right">
                            <p className='ShoppingDownload__left__item__bottom__title'>لورم ایپسوم   با تولید سادگی  از  چاپ</p>
                            <p className='ShoppingDownload__left__item__bottom__subtitle'>لورم ایپسوم   با تولید سادگی از چاپ</p>
                        </div>
                        <button className="ShoppingDownload__left__item__bottom__left">
                            مشاهده
                        </button>
                    </div>
                </div>




                <div className="ShoppingDownload__left__item">
                    <div className="ShoppingDownload__left__item__image">
                        <img src={shDownload} alt="" />
                    </div>
                    <div className="ShoppingDownload__left__item__bottom">
                        <div className="ShoppingDownload__left__item__bottom__right">
                            <p className='ShoppingDownload__left__item__bottom__title'>لورم ایپسوم   با تولید سادگی  از  چاپ</p>
                            <p className='ShoppingDownload__left__item__bottom__subtitle'>لورم ایپسوم   با تولید سادگی از چاپ</p>
                        </div>
                        <button className="ShoppingDownload__left__item__bottom__left">
                            مشاهده
                        </button>
                    </div>
                </div>




                <div className="ShoppingDownload__left__item">
                    <div className="ShoppingDownload__left__item__image">
                        <img src={shDownload} alt="" />
                    </div>
                    <div className="ShoppingDownload__left__item__bottom">
                        <div className="ShoppingDownload__left__item__bottom__right">
                            <p className='ShoppingDownload__left__item__bottom__title'>لورم ایپسوم   با تولید سادگی  از  چاپ</p>
                            <p className='ShoppingDownload__left__item__bottom__subtitle'>لورم ایپسوم   با تولید سادگی از چاپ</p>
                        </div>
                        <button className="ShoppingDownload__left__item__bottom__left">
                            مشاهده
                        </button>
                    </div>
                </div>




                <div className="ShoppingDownload__left__item">
                    <div className="ShoppingDownload__left__item__image">
                        <img src={shDownload} alt="" />
                    </div>
                    <div className="ShoppingDownload__left__item__bottom">
                        <div className="ShoppingDownload__left__item__bottom__right">
                            <p className='ShoppingDownload__left__item__bottom__title'>لورم ایپسوم   با تولید سادگی  از  چاپ</p>
                            <p className='ShoppingDownload__left__item__bottom__subtitle'>لورم ایپسوم   با تولید سادگی از چاپ</p>
                        </div>
                        <button className="ShoppingDownload__left__item__bottom__left">
                            مشاهده
                        </button>
                    </div>
                </div>
            </section>
        </div>
    </section>
  )
}
